<template>
  <div v-if="tel">
    <div v-if="tel.includes('Fax') || skipLink">
      {{
        skipTranslation
          ? tel
          : $t(translationKey, {
              number: tel,
            })
      }}
    </div>
    <a v-else :href="`tel:${formatTel}`" class="underline">
      {{
        skipTranslation
          ? tel
          : $t(translationKey, {
              number: tel,
            })
      }}
    </a>
  </div>
</template>

<script lang="ts">
import { CONTACT_INFO } from '~/config/contacts'
import type { ContactInfo } from '~/config/contacts'
import type { Locale } from '~/config/locales'

type phoneType = keyof Omit<ContactInfo, 'email' | 'url'>

export default defineComponent({
  name: 'Phone',
  props: {
    type: {
      type: String as PropType<phoneType>,
      required: true,
    },
    skipTranslation: {
      type: Boolean,
      default: false,
    },
    skipLink: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const currentShop = useCurrentShop()
    const contactInfo = computed(
      () => CONTACT_INFO[currentShop.value.locale as Locale]
    )

    const formatTel = computed(() => {
      return tel?.value?.replace(/[ \-/()]/g, '')
    })

    const tel = computed(() => contactInfo.value[props.type])

    const translationKey = computed(
      () => `customer-service.phone.${props.type}`
    )

    return { formatTel, contactInfo, tel, translationKey }
  },
})
</script>
